
import { useEffect } from 'react';
import { useMetricsLoader } from './metrics/useMetricsLoader';

/**
 * Hook for fetching and managing social metrics for content
 * Works with both polls and cards
 */
export const useSocialMetrics = (
  contentId: string,
  contentType: 'poll' | 'card' = 'card'
) => {
  // Load metrics and handle interaction with server
  const { 
    metrics, 
    isLoading, 
    loadMetrics 
  } = useMetricsLoader(contentId, contentType);
  
  // Update metrics on load and when dependencies change
  useEffect(() => {
    loadMetrics();
  }, [contentId, contentType]);

  return { metrics, isLoading };
};
